import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { Select } from '../../components/select'
import { Intent } from '../../config/intent'
import { countries } from '../../graphql/masa-types'

export const COUNTRIES_QUERY = gql`
    query countries($limit: Int) {
        listCountrys(limit: $limit) {
            items {
                id
                name
            }
        }
    }
`

interface CountrySelectProps {
    intent: Intent
    defaultValue?: string
    value: string
    onChange: (value: { value: string }) => void
}

interface Country {
    label: string
    value: string
}

export function CountrySelect({ intent, value, onChange }: CountrySelectProps) {
    const { data, loading } = useQuery<countries>(COUNTRIES_QUERY, {
        variables: { limit: 260 },
    })

    const countries: Country[] | undefined = useMemo(
        () =>
            loading
                ? []
                : data?.listCountrys?.items
                      ?.map(
                          (option: any) =>
                              ({
                                  label: option.name as string,
                                  value: option.id as string,
                              } as Country),
                      ) //@ts-ignore
                      ?.sort((a, b) =>
                          //@ts-ignore
                          a.label > b.label ? 1 : b.label > a.label ? -1 : 0,
                      ),
        [data, loading],
    )

    return (
        <Select
            value={value}
            options={countries ?? []}
            intent={intent}
            loading={loading}
            onChange={onChange}
        />
    )
}
